import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Template } from '../../models/api.models';
import { TemplatesService } from '../../services/templates.service';

@Component({
  selector: 'app-templates-page',
  templateUrl: './templates.page.html',
  styleUrls: ['./templates.page.scss'],
})
export class TemplatesPage implements OnInit {
  templates: Template[] = [];
  readonly form: UntypedFormGroup;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly templatesService: TemplatesService
  ) {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      category: ['marketing' as 'marketing' | 'utility', [Validators.required]],
      language: ['en', [Validators.required]],
      body: ['', [Validators.required]],
      variables: ['first_name, offer'],
    });
  }

  ngOnInit(): void {
    this.loadTemplates();
  }

  create(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    const payload: Template = {
      name: value.name,
      category: value.category,
      language: value.language,
      body: value.body,
      variables: String(value.variables)
        .split(',')
        .map((entry: string) => entry.trim())
        .filter(Boolean),
    };

    this.templatesService.create(payload).subscribe({
      next: () => {
        this.form.reset({
          name: '',
          category: 'marketing',
          language: 'en',
          body: '',
          variables: 'first_name, offer',
        });
        this.loadTemplates();
      },
    });
  }

  private loadTemplates(): void {
    this.templatesService.list().subscribe({
      next: (response) => {
        this.templates = response;
      },
      error: () => {
        this.templates = [
          {
            id: 1,
            name: 'promo_launch_v1',
            category: 'marketing',
            language: 'en',
            body: 'Hi {{1}}, your {{2}} is live today.',
            variables: ['customer_name', 'offer'],
            status: 'approved',
          },
          {
            id: 2,
            name: 'invoice_nudge',
            category: 'utility',
            language: 'en',
            body: 'Hello {{1}}, your invoice {{2}} is ready.',
            variables: ['customer_name', 'invoice_id'],
            status: 'draft',
          },
        ];
      },
    });
  }
}
